export default __webpack_public_path__ + "static/media/user.75217956.svg";